import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoRadio from '../../components/radio/pendo-radio.vue.js';
import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';
import PendoMultiselect from '../../components/multiselect/pendo-multiselect.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import startCase from 'lodash/startCase.js';

var script = {
  name: 'AgentSettingsModal',
  components: {
    PendoModal,
    PendoButton,
    PendoRadio,
    PendoRadioGroup,
    PendoMultiselect,
    PendoAlert
  },
  directives: {
    PendoTooltip
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agentVersions: {
      type: Array,
      default: () => []
    },
    agentSettings: {
      type: Object,
      default: () => ({})
    },
    isSaveLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      description: this.agentSettings.description,
      agentPolicy: this.agentSettings.agentPolicy,
      agentVersion: this.agentSettings.agentVersion,
      agentType: this.agentSettings.agentType,
      hasGuideValidation: this.agentSettings.hasGuideValidation,
      agentSupportsLightning: this.agentSettings.agentSupportsLightning,
      agentVersionIsDeprecated: this.agentSettings.agentVersionIsDeprecated,
      isStandardAgentDisabled: this.agentSettings.agentSupportsLightning
    };
  },
  computed: {
    title() {
      return `${startCase(this.agentSettings.description)} Settings`;
    },
    selectedAgentVersion() {
      return this.agentVersions.find(_ref => {
        let {
          value
        } = _ref;
        return value === this.agentVersion;
      });
    },
    selectionsHaveChanged() {
      return this.agentPolicy !== this.agentSettings.agentPolicy || this.agentVersion !== this.agentSettings.agentVersion || this.agentType !== this.agentSettings.agentType;
    },
    isSaveEnabled() {
      return this.selectionsHaveChanged && (this.agentPolicy === 'manual' ? !!this.selectedAgentVersion : true);
    }
  },
  watch: {
    agentSettings(newValue) {
      this.description = newValue.description;
      this.agentPolicy = newValue.agentPolicy;
      this.agentVersion = newValue.agentVersion;
      this.agentType = newValue.agentType;
      this.hasGuideValidation = newValue.hasGuideValidation;
      this.agentSupportsLightning = newValue.agentSupportsLightning;
      this.agentVersionIsDeprecated = newValue.agentVersionIsDeprecated;
      this.isStandardAgentDisabled = newValue.agentSupportsLightning;
    }
  },
  methods: {
    closeModal() {
      this.resetSelections();
      this.$emit('close');
    },
    resetSelections() {
      this.agentPolicy = this.agentSettings.agentPolicy;
      this.agentVersion = this.agentSettings.agentVersion;
      this.agentType = this.agentSettings.agentType;
    },
    changeAgentVersion(_ref2) {
      let {
        value
      } = _ref2;
      this.agentVersion = value;
    },
    resetToDefaults() {
      this.agentType = 'lightning';
      if (!this.agentSupportsLightning) {
        this.isStandardAgentDisabled = true;
      }
      if (this.description === 'staging') {
        this.agentPolicy = 'beta';
      } else {
        this.agentPolicy = 'stable';
      }
    },
    saveAgentSettings() {
      this.$emit('save', {
        agentPolicy: this.agentPolicy,
        agentVersion: this.agentVersion,
        agentType: this.agentType,
        description: this.description
      });
    },
    downloadAgent(_ref3) {
      let {
        agentType,
        description
      } = _ref3;
      this.$emit('downloadAgent', {
        agentType,
        description
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=agent-settings-modal.vue2.js.map
